import React, { useState } from 'react';
import { connect } from 'react-redux';
import CreatedExerciseForm from './CreatedExerciseForm';
import SearchEngine from './SearchEngine';

const ExerciesSearchBlock = props => {
  let { index, trainerExercies, values, setFieldValue } = props;
  const [selectedExercise, setselectedExercise] = useState(null);

  const handleSelectResult = exercise => {
    setselectedExercise(exercise);
  }

  const removeSelectedExercise = () => {
    setselectedExercise(null);
  }

  if (selectedExercise || values.ExerciesList[index]){
    return(
      <CreatedExerciseForm
        index={index}
        exercise={selectedExercise || values.ExerciesList[index]}
        values={values}
        setFieldValue={setFieldValue}
        removeSelectedExercise={removeSelectedExercise}
      />
    );
  }else{
    return (
      <div className="exercies-block" >
        <h4>Exercise {index+1}</h4>
        <div className="form-exercies">
          <SearchEngine trainerExercies={trainerExercies} selectResult={handleSelectResult} />
        </div>
      </div>
    );
  }
};


function mapStateToProps(state) {
  return {
    trainerExercies: state.workoutReducer.trainerExercies
  };
}

export default connect(
  mapStateToProps,
  null
)(ExerciesSearchBlock);
